// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1Dgni","label":"Section_label__3uOOi","contentWrap":"Section_contentWrap__3PR9K","footer":"Section_footer__7LvwO","footerInner":"Section_footerInner__Vi8oq"};